import type { PropsWithChildren, ReactNode } from "react";
import { X } from "lucide-react";

export function IconButton({ label, children, onClick, disabled = false, className = "" }: PropsWithChildren<{ label: string; onClick?: () => void; disabled?: boolean; className?: string }>) {
  return <button type="button" className={`icon-button ${className}`} aria-label={label} title={label} onClick={onClick} disabled={disabled}>{children}</button>;
}

export function Sheet({ title, children, onClose, footer }: PropsWithChildren<{ title: string; onClose: () => void; footer?: ReactNode }>) {
  return (
    <div className="sheet-backdrop" role="presentation" onPointerDown={(event) => { if (event.target === event.currentTarget) onClose(); }}>
      <section className="sheet" role="dialog" aria-modal="true" aria-label={title}>
        <header className="sheet-header"><h2>{title}</h2><IconButton label="关闭" onClick={onClose}><X /></IconButton></header>
        <div className="sheet-content">{children}</div>
        {footer && <footer className="sheet-footer">{footer}</footer>}
      </section>
    </div>
  );
}

export function EmptyState({ icon, title, description, action }: { icon: ReactNode; title: string; description: string; action?: ReactNode }) {
  return <div className="empty-state"><div className="empty-icon">{icon}</div><h3>{title}</h3><p>{description}</p>{action}</div>;
}

export function ProgressBar({ value, max, label }: { value: number; max: number; label?: string }) {
  const ratio = max ? Math.max(0, Math.min(100, value / max * 100)) : 0;
  return <div className="progress-wrap" aria-label={label ?? `已完成 ${value} / ${max}`}><div className="progress-track"><span style={{ width: `${ratio}%` }} /></div></div>;
}
